import { render, staticRenderFns } from "./UpgradeInfoDialog.vue?vue&type=template&id=32e8148f&"
import script from "./UpgradeInfoDialog.vue?vue&type=script&lang=js&"
export * from "./UpgradeInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports